import React, { useState } from "react";
import { Link } from "react-router-dom";

import logoDark from "../assets/images/logo-dark.svg";
import logoLight from "../assets/images/logo-light.svg";

// Import Components
import {
  Button,
  Col,
  Container,
  Row,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Breadcrumbs from "../Components/Common/Bredcrums";
import Search from "../Components/Common/Search";
import ProfileDropdown from "../Components/Common/ProfileDropdown";
import { ToastContainer } from "react-toastify";

const Header = ({ headerClass, theme }) => {
  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} limit={1} />
      <header id="page-topbar" className={`py-4 mb-2 ${headerClass}`}>
        <Container>
          <Row>
            <Col className="d-flex align-items-center gap-3">
              <div className="navbar-brand-box horizontal-logo">
                <Link
                  to="/"
                  className={`logo ${
                    theme === "dark" ? "logo-light" : "logo-dark"
                  }`}
                >
                  <img
                    src="https://assets.danubehome.com/media/assets/svg-v2/logoEn.svg"
                    alt="large logo"
                    height="18"
                  />
                </Link>
              </div>
              {/* <div className="d-flex gap-2 topNav">
                <Link
                  to="#"
                  className="px-2 d-flex align-items-center gap-1 fs-14 rounded-3"
                >
                  <i className="ri-tools-fill fs-18"></i> Content model
                </Link>
                <Link
                  to="#"
                  className="px-2 d-flex align-items-center gap-1 fs-14 rounded-3"
                >
                  <i className="ri-pen-nib-line fs-18"></i>Content
                </Link>
                <Link
                  to="#"
                  className="px-2 d-flex align-items-center gap-1 fs-14 rounded-3"
                >
                  <i className="ri-image-2-line fs-18"></i> Media
                </Link>
                <Link
                  to="#"
                  className="px-2 d-flex align-items-center gap-1 fs-14 rounded-3"
                >
                  <i className="mdi mdi-puzzle-outline fs-18"></i>App
                </Link>
              </div> */}
            </Col>
            <Col>
              <div className="d-flex gap-2 align-items-center justify-content-end topNavEnd">
                {/* <Link
                  to="#"
                  className="px-2 d-flex align-items-center gap-1 fs-14 rounded-3 text-info"
                >
                  <i className="bx bxs-megaphone fs-18"></i>Give feedback
                </Link>

                <Breadcrumbs /> */}
                {/* <Search />
                <UncontrolledDropdown group>
                  <DropdownToggle
                    size="sm"
                    color="light"
                    className="shadow-none d-flex justify-content-center align-items-center rounded-3"
                  >
                    <i className="bx bx-help-circle fs-18"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem header className="text-muted fs-11">
                      Header
                    </DropdownItem>
                    <DropdownItem className="fs-14">Some Action</DropdownItem>
                    <DropdownItem text className="text-muted fs-11">
                      Dropdown Item Text
                    </DropdownItem>
                    <DropdownItem disabled className="fs-14">
                      Action (disabled)
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem className="fs-14">Foo Action</DropdownItem>
                    <DropdownItem className="fs-14">Bar Action</DropdownItem>
                    <DropdownItem className="fs-14">Quo Action</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown> */}
                {/* <Button
                  size="sm"
                  color="light"
                  className="shadow-none d-flex justify-content-center align-items-center"
                >
                  <i className="bx bx-book-open fs-18"></i>
                </Button> */}
                {/* <UncontrolledDropdown group>
                  <DropdownToggle
                    size="sm"
                    color="light"
                    className="shadow-none d-flex justify-content-center align-items-center rounded-3"
                  >
                    <i className="bx bx-cog fs-18"></i>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem header className="text-muted fs-11">
                      Header
                    </DropdownItem>
                    <DropdownItem className="fs-14">Some Action</DropdownItem>
                    <DropdownItem text className="text-muted fs-11">
                      Dropdown Item Text
                    </DropdownItem>
                    <DropdownItem disabled className="fs-14">
                      Action (disabled)
                    </DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem className="fs-14">Foo Action</DropdownItem>
                    <DropdownItem className="fs-14">Bar Action</DropdownItem>
                    <DropdownItem className="fs-14">Quo Action</DropdownItem>
                  </DropdownMenu>
                </UncontrolledDropdown> */}
                <ProfileDropdown />
              </div>
            </Col>
          </Row>
        </Container>
      </header>
    </React.Fragment>
  );
};

export default Header;
